export default __webpack_public_path__ + "static/media/github.22e65707.svg";